import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import React, { useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import contactUsCss from "./ContactUs.module.css";
import RestClient from "../../RestApi/RestClient";
import AppUrl from "../../RestApi/AppUrl";
export default function ContactUS() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const postData = { name, email, message };
    RestClient.PostRequest(AppUrl.ContactForm, JSON.stringify(postData)).then(
      (result) => console.log(result)
    );
  };
  return (
    <>
      <Container className="mt-4">
        <Row>
          <Col lg={12} md={12} sm={12}>
            <h1 className={`${contactUsCss.title} text-center p-3`}>
              Quick Connect
            </h1>
            <Row>
              <Col lg={8} md={8} sm={12} className="mx-auto">
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mt-3 mb-3" controlId="formBasicEmail">
                    <Form.Label>Your Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter email"
                      name="name"
                      onChange={(e) => setName(e.target.value)}
                    />
                  </Form.Group>
                  <Form.Group className="mt-3 mb-3" controlId="formBasicEmail">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Enter email"
                      name="email"
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </Form.Group>
                  <Form.Group
                    className="mb-3 mt-3"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Label>Your Message</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="message"
                      onChange={(e) => setMessage(e.target.value)}
                    />
                  </Form.Group>
                  <Button variant="primary" type="submit" className="mt-2 mb-2">
                    Submit
                  </Button>
                </Form>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
}
